import { MarkerType } from '@xyflow/react';

import DefaultNode from './node/DefaultNode';
import LineEdge from './edge/LineEdge';
import BezierEdge from './edge/BezierEdge';
import SelfConnectingEdge from './edge/SelfConnectingEdge';
import DefaultConnectionLine from './edge/DefaultConnectionLine';
import getDirectedGraphLayout from './layout/getDirectedGraphLayout';
import NoteNode from './node/NoteNode';

import WorkflowStepNode from './node/WorkflowStepNode';
import RoleBackground from './background/RoleBackground';

import DirectedGraphItemNode from './node/DirectedGraphItemNode';

export const DEFAULT_NODE_TYPES = {
  default: DefaultNode,
  workflowstep: WorkflowStepNode,
  item: DirectedGraphItemNode,
  note: NoteNode,
};

export const DEFAULT_EDGE_TYPES = {
  default: LineEdge,
  bezier: BezierEdge,
  selfconnecting: SelfConnectingEdge,
  item: LineEdge,
};

export const DEFAULT_EDGE_OPTIONS = {
  type: 'default',
  animated: true,
  labelShowBg: true,
  style: {
    strokeWidth: 1,
    stroke: 'gray',
  },
};

export const DEFAULT_CONNECTION_LINE_STYLE = {
  strokeWidth: 1,
  stroke: 'black',
};

export const NOTE_W = 220;
export const NOTE_H = 110;

export { DefaultNode, LineEdge, DefaultConnectionLine, getDirectedGraphLayout, RoleBackground, WorkflowStepNode };
